import IvrTrackingPage from './IvrTrackingPage'
export default IvrTrackingPage